/**
 * Renderer for the `status` column.
 *
 * The server still returns an HTML-formatted status chip
 * (`<span class='label label-success'>Active</span>`). Display uses the
 * Quimby Status atom with that chip's background color as the dot color.
 * This is display-only — status is not edited inline.
 *
 * Falls back to a dash when the value is null.
 */
import React from 'react';
import { Status } from '@ui/atoms/Status/Status';
import { parseSeriesStatusHtml } from './parseSeriesStatus';
export function SeriesStatusRenderer({ item }) {
    if (!item.status)
        return React.createElement("span", null, "-");
    const { label, color } = parseSeriesStatusHtml(item.status);
    return React.createElement(Status, { label: label, color: color });
}
